import { takeLatest, call } from "redux-saga/effects";
import { pushEvent } from "./actions.js";
import { pushEvent as pushEvent$1 } from "./helpers.js";
function* onPushEvent(action) {
  yield call(pushEvent$1, { ...action.payload });
}
const dataLayerSagas = [takeLatest(pushEvent.type, onPushEvent)];
export {
  dataLayerSagas as default,
  onPushEvent
};
//# sourceMappingURL=sagas.js.map
